<template>
  <div class="elasticacheResourceSearch">
    <Row :gutter="4" style="margin-bottom: 10px;">
      <!-- 选择公司 -->
      <div v-if="companyIdCookie == 1">
        <Col span="6">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('RAM.common.PleaseSelectCompany')"
            :transfer="true"
            @on-change="getAccount()"
          >
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>
      <!-- 选择账号 -->
      <Col span="6">
        <Select
          v-model="accountIds"
          filterable
          multiple
          :max-tag-count="1"
          :placeholder="$t('RAM.common.PleaseSelectAccount')"
          @on-change="changeAccount(accountIds)"
          :transfer="true"
        >
          <Checkbox
            v-model="singleAccount"
            @on-change="selectAllAccount"
            style="display: block;text-align:right;"
            >{{ $t("alarms.common.allSelected") }}</Checkbox
          >
          <Option :value="item.id" v-for="item in accountList" :key="item.id">{{
            item.name
          }}</Option>
        </Select>
      </Col>
      <!-- 选择区域 -->
      <Col span="6">
        <Select
          v-model="regions"
          multiple
          :max-tag-count="1"
          :placeholder="$t('RAM.common.PleaseSelectRegion')"
          :transfer="true"
          @on-change="changeRegion(regions)"
        >
          <Checkbox
            v-model="singleRegion"
            @on-change="selectAllRegion"
            style="display: block;text-align:right;"
            >{{ $t("alarms.common.allSelected") }}</Checkbox
          >
          <Option
            :value="item.name"
            v-for="item in regionList"
            :key="item.id"
            >{{ item.name }}</Option
          >
        </Select>
      </Col>
      <!-- 标签值查询 -->
      <Col span="6">
        <Input
          v-model="tagValue"
          :placeholder="$t('RAM.common.PleaseSelectTagValue')"
        />
      </Col>
    </Row>
    <Row :gutter="4">
      <!-- 账户ID查询 -->
      <!-- <Col span="3">
                <Input search v-model="awsId" :placeholder="$t('RAM.common.PleaseEnterAccountID')" />
            </Col> -->
      <!-- 付款选项查询 -->
      <Col span="6">
        <Select
          v-model="engine"
          :placeholder="$t('RAM.common.PleaseSelectEngine')"
          :transfer="true"
        >
          <Option value="">{{ $t("alarms.common.all") }}</Option>
          <Option
            :value="item.name"
            v-for="item in engineList"
            :key="item.id"
            >{{ item.name }}</Option
          >
        </Select>
      </Col>
      <!-- 状态查询 -->
      <Col span="6">
        <Select
          v-model="state"
          :placeholder="$t('RAM.common.PleaseSelectStatus')"
          :transfer="true"
        >
          <Option value="">{{ $t("alarms.common.all") }}</Option>
          <Option :value="item.name" v-for="item in stateList" :key="item.id">{{
            item.name
          }}</Option>
        </Select>
      </Col>
      <Col span="6">
        <DatePicker
          type="month"
          :placeholder="$t('RAM.common.PleaseSelectExpirationTime')"
          v-model="expiration"
          format="yyyy-MM"
          style="width:100%;"
        ></DatePicker>
      </Col>
      <Col span="2">
        <Button
          @click="search()"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:reservedInstanceResource:elasticCache:search'
          ]"
          >{{ $t("alarms.common.search") }}</Button
        >
      </Col>
    </Row>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../../../utils/cookieUtil.js";
import TableElasticacheResource from "../elasticache/TableElasticacheResource";
var tableElasticacheResource = TableElasticacheResource;
export default {
  name: "ElasticacheResourceSearch",
  data() {
    return {
      engine: "",
      engineList: [
        {
          id: 0,
          name: "redis"
        },
        {
          id: 1,
          name: "memcached"
        }
      ],
      state: "",
      stateList: [
        {
          id: 0,
          name: "active"
        },
        {
          id: 1,
          name: "retired"
        }
      ],
      companyIdCookie: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      accountList: [],
      accountIds: [],
      regions: [],
      singleAccount: false,
      regionList: [],
      singleRegion: false,
      expiration: "",
      awsId: "",
      tagValue: ""
    };
  },
  mounted: function() {
    // 查询公司下拉框
    this.getCompanyDropDownBox();
    // 初始化账号信息
    this.getAccount();
  },
  methods: {
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    },
    /****************************账号******************************/
    // 查询账号
    getAccount: function() {
      // 清空数组
      this.accountList = [];
      // 清空选中的数据
      this.accountIds = [];
      // 清空复选框
      this.singleAccount = false;
      // 如果不是冠闵用户
      if (this.companyIdCookie != 1) {
        this.companyId = this.companyIdCookie;
      }
      // 账号下拉框
      this.$api.account
        .queryAccountListByCompanyIdAndCloudType({
          companyId: this.companyId,
          cloudPlatformType: 0
        })
        .then(res => {
          if (res.data != null && res.data.length > 0) {
            this.accountList = res.data;
            // 默认全选账户
            for (var i = 0; i < this.accountList.length; i++) {
              this.accountIds.push(this.accountList[i].id);
            }
            this.singleAccount = true;
          }
        });
    },
    // 查询地区
    changeAccount: function(val) {
      if (val.length === this.accountList.length && val.length != 0) {
        this.singleAccount = true;
      } else {
        this.singleAccount = false;
      }
      // 清空数组
      this.regionList = [];
      // 清空选择的数据
      this.regions = [];
      // 清空复选框
      this.singleRegion = false;
      let account = "";
      if (val.length >= 1) {
        account = val[0];
      } else {
        return;
      }
      this.$api.account.queryAccountRegions("accountId", account).then(res => {
        if (res.data != null && res.data.length > 0) {
          this.regionList = res.data;
          // 默认全选区域
          for (var i = 0; i < this.regionList.length; i++) {
            this.regions.push(this.regionList[i].name);
          }
          this.singleRegion = true;
        }
      });
    },
    // 全选账号
    selectAllAccount() {
      this.accountIds = [];
      if (this.singleAccount) {
        this.accountList.map(item => {
          this.accountIds.push(item.id);
        });
      } else {
        this.accountIds = [];
      }
    },
    /****************************区域******************************/
    // 切换区域
    changeRegion: function(val) {
      if (val.length === this.regionList.length && val.length != 0) {
        this.singleRegion = true;
      } else {
        this.singleRegion = false;
      }
    },
    // 全选区域
    selectAllRegion: function(val) {
      this.regions = [];
      if (this.singleRegion) {
        this.regionList.map(item => {
          this.regions.push(item.name);
        });
      } else {
        this.regions = [];
      }
    },
    //点击查询 加载全部数据
    /***********************************************************************************/
    search: function() {
      if (this.accountIds == "" || this.accountIds == null) {
        this.$Message.warning(this.$t('RAM.common.PleaseSelectAccount'), 5);
        return;
      }
      if (this.regions == "" || this.regions == null) {
        this.$Message.warning(this.$t('RAM.common.PleaseSelectRegion'), 5);
        return;
      }

      var reservedInstanceDTO = {
        initAccountType: 2,
        accountIds: this.accountIds,
        regions: this.regions,
        engine: this.engine,
        state: this.state,
        expiration: this.expiration,
        accountId: this.awsId,
        tagValue: this.tagValue,
        companyId:
          this.companyId == null ||
          this.companyId == "" ||
          this.companyId == undefined
            ? this.companyIdCookie
            : this.companyId
      };

      // 调用查询接口
      tableElasticacheResource.methods.getReservedInstances(
        reservedInstanceDTO
      );
    }
  }
};
</script>
<style scoped>
.elasticacheResourceSearch {
  padding: 4px 0px 11px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/reserved_instance/elasticache/ElasticacheResourceSearch.vue